<template>
  <div id="app" class="module">
    <router-view @onShowLogin="showLogin"/>
<!--    title="登录"-->
    <a-modal
      :visible="showLoginModal"
      @cancel="handleCancel"
      :closable="true"
      :maskClosable="false"
      class="serviceGuideModal"
      :footer="null"
      :centered="true"
    >
      <div class="login_panel" v-if="!$store.state.isMobile">
        <a-tabs class="login_tab" default-active-key="1" @change="callback">
          <a-tab-pane key="1" tab="扫码登录">
            <div class="qr_div_main">
              <!--二维码已过期-->
              <div class="status_item" v-if="this.qrStatus === '4'">
                <div>
                  <div class="qr_image_box" >
                    <img class="qr_image_status" :src="icon_refresh_mian" width="207" alt="scan" @click="rotateIcon" :class="{ 'rotate': isRotating }"/>
                  </div>
                  <div class="login_qr_tip">
                    二维码已过期，请刷新重试
                  </div>
                </div>
              </div>

              <!--扫码成功-->
              <div class="status_item" v-if="this.qrStatus === '2'">
                <div>
                  <div class="qr_image_box" >
                    <img class="qr_image_status" :src="qrScanOk" width="207" alt="scan" @click="rotateIcon"/>
                  </div>
                  <div class="login_qr_tip">
                    APP已扫码，请及时确认登录
                  </div>
                </div>
              </div>

              <!-- 待扫码状态-->
              <div v-if="this.qrStatus === '1'">
                <div class="qr_image_box" >
                  <img class="qr_image" :src="qrCodeImage" width="207" alt="scan"/>
                </div>
                <div class="login_qr_tip">
                  打开喵呜APP - 我的 - 右上角扫码
                </div>
              </div>

              <!-- 已确认成功 不用作-->
              <div v-if="this.qrStatus === '16'">
                <div class="qr_image_box" >
                  <img class="qr_image" :src="qrPath" width="207" alt="scan" v-if="this.qrStatus === '4'"/>
                  <img class="qr_image" :src="qrCodeImage" width="207" alt="scan" v-if="this.qrStatus !== '4'"/>
                  <img class="qr_image" :src="qrScanOk" width="207" alt="scan" v-if="this.qrStatus === '2'"/>
                  <div class="qr_invalid" v-if="this.qrStatus === '4' || this.qrStatus === '2'" @click="rotateIcon">
                  </div>
                  <div class="new_icon_div" v-if="this.qrStatus === '4' || this.qrStatus === '2' ">
                    <a-icon type="redo" class="icon_refresh" :class="{ 'rotate': isRotating }" @click="rotateIcon"/>
                    <div class="icon_refresh_text" >
                      刷新二维码
                    </div>
                  </div>

                </div>
                <div class="login_qr_tip">
                  <div v-if="this.qrStatus === '1'">打开喵呜APP - 我的 - 右上角扫码{{this.qrStatus}}</div>
                  <div v-if="this.qrStatus === '2'">设备已扫码{{this.qrStatus}}</div>
                  <div v-if="this.qrStatus === '3'">设备已确认{{this.qrStatus}}</div>
                  <div v-if="this.qrStatus === '4'">二维码已过期{{this.qrStatus}}</div>
                </div>
              </div>

            </div>
          </a-tab-pane>
          <a-tab-pane key="2" tab="账号登录" force-render>
            <div class="login_way_box" style="padding: 20px 40px">
              <a-row class="login_panel_title">登录您的喵呜AI</a-row>
              <a-row class="login_panel_input">
                <img :src="phonePath" alt="Custom Image" class="custom-icon-lock" />
                <a-input class="input_login_custom" ref="userNameInput" v-model="phone" placeholder="请输入您的手机号">
                  <!--                <a-icon slot="prefix" type="tablet" />-->
                </a-input>
              </a-row>
              <a-row class="login_panel_input">
                <img :src="lockPath" alt="Custom Image" class="custom-icon-lock" />
                <a-input class="input_login_custom" ref="userNameInput" v-model="password"  type="password" placeholder="请输入您的密码">

                  <!--                <a-icon slot="prefix" type="lock"/>-->
                </a-input>
              </a-row>
              <a-row class="login_panel_tips">请使用您的喵呜账号登录，若您还没有<span class="color_green" @click=jumpCooperate>注册喵呜账号</span>
                ，请联系商务获取注册码后下载app注册登录</a-row>
              <a-row class="login_panel_btn">
                <a-button type="primary" class="btn_now" @click="login">
                  登录
                </a-button>
              </a-row>
            </div>

          </a-tab-pane>
        </a-tabs>
      </div>
      <div class="login_panel_mobile" v-else>
        <a-row class="login_panel_title">登录您的喵呜AI</a-row>
        <a-row class="login_panel_input">
          <img :src="phonePath" alt="Custom Image" class="custom-icon-lock" />
          <a-input class="input_login_custom input_login_custom_mobile" ref="userNameInput" v-model="phone" placeholder="请输入您的手机号">
          </a-input>
        </a-row>
        <a-row class="login_panel_input">
          <img :src="lockPath" alt="Custom Image" class="custom-icon-lock" />
          <a-input class="input_login_custom input_login_custom_mobile" ref="userNameInput" v-model="password"  type="password" placeholder="请输入您的密码">
          </a-input>
        </a-row>
        <a-row class="login_panel_tips">请使用您的喵呜账号登录，若您还没有<span class="color_green" @click=jumpCooperate>注册喵呜账号</span>
          ，请联系商务获取注册码后下载app注册登录</a-row>
        <a-row class="login_panel_btn">
          <a-button type="primary" class="btn_now" @click="login">
            登录
          </a-button>
        </a-row>
      </div>
      <!-- <template #title>
        <div style="text-align: center; font-size: 20px; color: #1890ff;">Custom Modal Title</div>
      </template>-->
    </a-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import VueMeta from 'vue-meta'
import CryptoJS from 'crypto-js'
import QRCode from 'qrcode'
Vue.use(VueMeta)

export default {
  name: 'App',
  /* metaInfo: {
    link: [
      {
        rel: 'icon',
        href: '/favicon.ico'
      }
    ]
  }, */
  provide () {
    return {
      showLogin: this.showLogin
    }
  },
  data () {
    return {
      qrPath: require('@/assets/qr_default.png'),
      phonePath: require('@/assets/icon/icon-phone.png'),
      lockPath: require('@/assets/icon/icon-lock.png'),
      qrScanOk: require('@/assets/icon_qr_ok.png'),
      icon_refresh_mian: require('@/assets/icon_refresh_mian.png'),
      qrCodeImage: '',
      qrStatus: '4',
      countStatus: 0, // 获取轮询次数
      showLoginModal: false,
      phone: '',
      password: '',
      isMobile: false,
      isRotating: false
    }
  },
  created () {
    this.checkDevice()
  },
  mounted () {
    /* const aesKey = 'm1i2a3o4w5u61020'
    const aesIv = '2023102117451234'
    const paramsJson = {
      'identity': '19968160979',
      'password': 'lh@123456'
    }
    const paramsJsonStr = JSON.stringify(paramsJson)
    // 加密
    let encryptContent = this.encrypt(paramsJsonStr, aesKey, aesIv)
    console.log('encryptContent:', encryptContent)
    let jiemi = this.decrypt(encryptContent, aesKey, aesIv)
    console.log('jiemi', jiemi) */
  },
  methods: {
    newQr () {
      this.qrStatus = '1'
      const random = this.generateRandomString(16)
      // 计算字符串的 MD5 哈希值
      const hash = CryptoJS.MD5(random + 'miaowu').toString()
      const params = {
        scene_id: random,
        scene_token: hash
      }
      this.$api.getLoginQrCode(params).then(res => {
        if (res && res.status === 200) {
          const resData = res.data.data
          const codeId = resData.code_id
          if (typeof codeId !== 'undefined' && codeId !== '') {
            this.generateQRCode(codeId)
          }
        } else {
          console.log('getLoginQrCode data fail:', res)
          this.qrStatus = '4'
        }
      }).catch(error => {
        this.qrStatus = '4'
        console.log('getLoginQrCode data error:', typeof error, error)
        if (error.message === 'Network Error') {
          this.$message.error('网络已断开，请先检查网络')
        }
      })
    },
    // 生成二维码
    generateQRCode (qrText) {
      QRCode.toDataURL(qrText)
        .then(url => {
          this.qrCodeImage = url
          // console.log('this.qrCodeImage:', this.qrCodeImage)
          // 开始轮询
          if (this.timerQr != null) {
            clearInterval(this.timerQr)
          }

          this.timerQr = setInterval(() => {
            this.countStatus = this.countStatus + 1
            /*  if (this.countStatus > 30) {
              this.qrStatus = '4'
              return
            } */
            if (this.qrStatus === '4') {
              return
            }
            const params = {
              code_id: qrText
            }
            this.$api.getQrStatus(params).then(res => {
              if (res && res.status === 200) {
                const resData = res.data.data
                // console.log('resData:', resData)
                const status = resData.status // 1：待扫码；2：已扫码；3：已确认；4：已过期
                const userToken = resData.user_token
                this.qrStatus = status
                /* if (status === '2') {
                  // 开始计算过期次数
                  this.lostCount = this.lostCount + 1
                } */
                /* if (this.lostCount > 10) {
                  // 扫码后超过30s则为过期
                  this.qrStatus = '4'
                  this.stopTimer()
                  return
                } */
                if (status === '4') {
                  this.stopTimer()
                  return
                }
                if (userToken !== '') {
                  this.$message.success('扫码登录成功！')
                  // 停止轮询
                  this.stopTimer()
                  // 保存和应用token
                  // 关闭弹框
                  const token = 'Bearer ' + userToken
                  this.whenGetToken(token, '')
                }
              } else {
                console.log('login_qr_code_status data fail:', res)
                this.stopTimer()
              }
            }).catch(error => {
              console.log('login_qr_code_status data error:', error)
            })
          }, 3 * 1000)
        })
        .catch(err => {
          console.error(err)
          this.stopTimer()
        })
    },
    stopTimer () {
      if (this.timerQr !== null) {
        clearInterval(this.timerQr)
        this.timerQr = null
      }
    },
    generateRandomString (length) {
      let result = ''
      const characters = 'abcdefghijklmnopqrstuvwxyz0123456789'
      const charactersLength = characters.length
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength))
      }
      return result
    },
    rotateIcon () {
      this.isRotating = true
      setTimeout(() => {
        this.isRotating = false
        this.countStatus = 0
        this.newQr()
      }, 1000) // 1秒后停止旋转
    },
    callback (key) {
      console.log('table changed:', key)
    },
    checkDevice () {
      const userAgent = navigator.userAgent.toLowerCase()
      const mobileKeywords = ['iphone', 'android', 'windows phone']
      this.isMobile = mobileKeywords.some(keyword => userAgent.includes(keyword))
      console.log('isMobile', this.isMobile)
      this.$store.commit('updateMobile', this.isMobile)
    },
    showLogin () {
      this.showLoginModal = true
      this.newQr()
    },
    isNumeric (str) {
      return /^\d+$/.test(str)
    },
    encrypt (content, key, iv) {
      return CryptoJS.AES.encrypt(content, CryptoJS.enc.Utf8.parse(key), {
        iv: CryptoJS.enc.Utf8.parse(iv),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }).ciphertext.toString()
    },
    // 解密方法
    decrypt (content, key, iv) {
      let key2 = CryptoJS.enc.Utf8.parse(key)
      let iv2 = CryptoJS.enc.Utf8.parse(iv)
      let result = CryptoJS.AES.decrypt(content, key2, {
        iv: iv2,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      })
      let result2 = result.toString(CryptoJS.enc.Utf8)
      return result2
    },
    encryptData (data, key, iv) {
      let key2 = CryptoJS.enc.Utf8.parse(key) // 16位iv
      let iv2 = CryptoJS.enc.Utf8.parse(iv) // 16位iv
      let encrypted = CryptoJS.AES.encrypt(data, key2, {
        iv: iv2,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      })
      return encrypted.toString()
    },

    decryptData (data, key, iv) {
      let key2 = CryptoJS.enc.Utf8.parse(key)
      let iv2 = CryptoJS.enc.Utf8.parse(iv) // 16位iv
      let decrypted = CryptoJS.AES.decrypt(data, key2, {
        iv: iv2,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      })
      return decrypted.toString(CryptoJS.enc.Utf8)
    },
    login () {
      // 消除字符串的首尾空格。
      this.phone = this.phone.trim()
      this.password = this.password.trim()
      // 判断用户名 密码 是否为空
      if (this.phone === '') {
        this.$message.error('手机号不能为空')
        return
      }
      if (this.password === '') {
        this.$message.error('密码不能为空')
        return
      }
      if (!this.isNumeric(this.phone)) {
        this.$message.error('手机号格式不符合要求')
        return
      }
      if (!this.validPassword(this.password)) {
        this.$message.error('密码格式不符合要求')
        return
      }
      // 请求密钥
      this.$api.getAesKey().then(res => {
        if (res && res.status === 200) {
          const resData = res.data.data
          if (resData && typeof resData !== 'undefined') {
            let keyData = resData.key_data
            let keyStr = resData.key_str
            // 解密API
            let jieApiContent = this.decryptData(keyData, keyStr, keyStr)
            let jieApiContentjson = JSON.parse(jieApiContent)
            let aesKey = jieApiContentjson.aes_key
            let aesIv = jieApiContentjson.aes_iv

            const paramsJson = {
              'identity': this.phone,
              'password': this.password,
              'login_type': 'h5'
            }
            const paramsJsonStr = JSON.stringify(paramsJson)
            // 加密
            let encryptContent = this.encryptData(paramsJsonStr, aesKey, aesIv)
            // console.log('encryptContent', encryptContent)

            let newJsonParams = {
              data: encryptContent
            }
            // 登录方法
            this.$api.login(newJsonParams).then(res => {
              if (res && res.status === 200) {
                const responseData = res.data
                if (responseData.status === 'ok') {
                  this.$message.success('登录成功')
                  const token = 'Bearer ' + responseData.data.access_token
                  this.whenGetToken(token, this.phone)
                }
              }
              /* else {
                console.log('登录失败l ', res.)
              } */
            }).catch(error => {
              console.log('登录失败:', error)
              if (error.data.msg === '邮箱格式不正确') {
                this.$message.error('登录失败登录账号错误')
              } else {
                this.$message.error('登录失败' + error.data.msg)
              }
            })
          }
        } else {
          console.log('aes data fail:', res)
        }
      }).catch(error => {
        console.log('aes data error:', error)
      })
    },
    whenGetToken (token, phone) {
      console.log('enter whenGetToken')
      let userAuth = {}
      userAuth.username = phone
      userAuth.accessToken = token
      userAuth.password = ''
      userAuth.userToken = token
      userAuth.haveLogin = true
      this.$store.commit('updateUserAuth', userAuth)
      this.$store.commit('updateShowPanel', false)
      this.showLoginModal = false

      this.$api.getUserInfo().then(res => {
        if (res && res.status === 200) {
          const resData = res.data.data
          if (resData && typeof resData !== 'undefined') {
            let userInfo = {}
            if (resData.length > 0) {
              userInfo = resData[0]
            }
            let userAuth = this.$store.state.userAuth
            userAuth.username = userInfo.phone
            this.$store.commit('updateUserAuth', userAuth)
            this.$store.commit('updateUserInfo', userInfo)
          }
        } else {
          const resData = res.data.data
          let apiMsg = resData.msg
          if (typeof apiMsg === 'undefined') {
            this.$message.error('用户信息获取失败' + res.status)
          } else {
            this.$message.error(apiMsg)
          }
        }
      }).catch(error => {
        console.log('当前用户信息获取失败:', error)
        const resData = error.data.data
        let apiMsg = resData.msg
        if (typeof apiMsg === 'undefined') {
          this.$message.error('用户信息获取失败' + error.status)
        } else {
          this.$message.error(apiMsg)
        }
      })

      // 请求项目列表
      this.$api.projectList(this.phone, token).then(res => {
        if (res && res.status === 200) {
          const resData = res.data.data
          if (resData && typeof resData !== 'undefined') {
            if (resData.length === 0) {
              setTimeout(() => {
                this.$message.error('用户尚未创建项目')
              }, 2000)
            } else {
              this.$store.commit('updateProject0', resData[0])
            }
          }
        } else {
          setTimeout(() => {
            this.$message.error('用户项目获取失败')
          }, 2000)
        }
      }).catch(error => {
        console.log('当前用户项目获取失败:', error)
        this.$message.error('当前用户项目获取失败')
      })
    },
    jumpCooperate () {
      this.showLoginModal = false
      this.$router.push({ path: '/help', query: { contact: 2 } })
    },
    validPassword (testString) {
      const regex = new RegExp(/^(?=.*[a-zA-Z])(?=.*[!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~])(?=.*\d)[a-zA-Z\d!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]{8,20}$/)
      if (regex.test(testString)) {
        return true
      } else {
        return false
      }
    },
    handleCancel () {
      // 清理定时器
      if (this.timerQr != null) {
        clearInterval(this.timerQr)
        this.timerQr = null
        this.countStatus = 0
      }
      this.showLoginModal = false
    }
  },
  beforeDestroy () {
    // 清理定时器
    if (this.timerQr != null) {
      clearInterval(this.timerQr)
      this.timerQr = null
      this.countStatus = 0
    }
  }
}
</script>

<style lang="less">
#app {
  //font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-family: PingFang SC, PingFang SC;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  overflow: hidden;
  user-select: none;
  background-image: url("assets/module.jpg");
  background-size: cover;
}
img[lazy="loading"] {
  width: 106px;
  height: 98px;
}
.module{
  width: 100vw;
  min-height: 100vh;
  display: block;
  /*background-image: url("assets/module.jpg");
  background-size: cover;*/
}
@media (max-width: 450px) {
  .module{
    height: auto;
    background-size: auto;
  }
}
.txt_align_left{
  text-align: left;
}
body{
  margin: 0;
}
.div_left{
  float: left;
}
.color_green{
  color: #28E04A
}
.login_panel_btn{
  display: flex;
  text-align: center;
  justify-content: center;
}
.login_panel{
  height: 482px;
  background: #FFFFFF;
  border-radius: 12px;
  opacity: 1;
  // padding: 24px 28px 24px 28px;
  .qr_div_main{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    .status_item{
      width: 300px;
      height: 300px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .qr_image_box{
      display: flex;
      justify-content: center;
      position: relative;
    }
    .qr_image{
      width: 207px;
      height: 207px;
    }
    .qr_image_status{
      width: 100px;
      height: 100px;
    }
    .qr_invalid{
      position: absolute;
      z-index: 9;
      width: 207px;
      height: 207px;
      left: 0;
      top: 0;
      background: rgb(204, 204, 204);
      opacity: 0.8;
      display: flex;
      justify-content: center;
      align-items: center;
      backdrop-filter: blur(15px);
    }
    .new_icon_div{
      width: 100px;
      height: 100px;
      background: white;
      left: calc(50% - 50px);
      top: calc(50% - 50px);
      position: absolute;
      .icon_refresh{
        left: calc(50% - 20px);
        top: calc(50% - 20px);
        position: absolute;
        z-index: 10;
        font-size: 40px;
        opacity: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;
        /*transform: translate(-50%, -50%);*/
      }
      .icon_refresh_text{
        position: absolute;
        top: calc(50% + 23px);
        left: 0;
        color: white;
        font-size: 16px;
        width: 100%;
        height: 18px;
        text-align: center;
        z-index: 99;
      }
    }

    .login_qr_tip{
      float: left;
      width: 100%;
      height: 18px;
      font-weight: 400;
      font-size: 15px;
      color: #000000;
      line-height: 15px;
      font-style: normal;
      text-transform: none;
      text-align: center;
      margin-top: 18px;
      font-family: PingFang SC, PingFang SC;
    }
  }
  .login_panel_title{
    font-size: 36px;
    font-weight: 500;
    color: rgba(0,0,0,0.75);
    line-height: 42px;
    margin-bottom: 40px;
    font-family: PingFang SC !important;
    font-style: normal;
    text-transform: none;
    text-align: center;
  }
  .login_panel_input{
    font-size: 16px;
    font-weight: 400;
    color: #999999;
    line-height: 19px;
    margin-bottom: 24px;
    .input_login_custom{
      width: 398px;
      height: 62px;
      border-radius: 10px 10px 10px 10px;
      padding-left: 50px !important;
      .ant-input{
        height: 62px;
        font-size: 16px;
        font-weight: 400;
        color: #999999;
        line-height: 19px;
      }
    }
  }
  .login_panel_tips{
    font-size: 12px;
    font-weight: 400;
    color: #333333;
    line-height: 18px;
    letter-spacing: 1px;
    text-align: left;
    margin-bottom: 32px;
  }
  .btn_now{
    width: 166px !important;
    height: 54px !important;
    background: #28E04A !important;
    border-radius: 8px 8px 8px 8px;
    border-color: #28E04A !important;
    opacity: 1;
    font-size: 18px !important;
    font-weight: 600 !important;
    color: #000c17 !important;
  }
  .btn_now:hover{
    background: rgb(60, 244, 94) !important;
    color: #000c17 !important;
  }
}

.login_panel_mobile{
  height: 482px;
  background: #FFFFFF;
  border-radius: 12px;
  opacity: 1;
  padding: 10px 0 0 0;
  .login_panel_title{
    font-size: 36px;
    font-weight: 500;
    color: rgba(0,0,0,0.75);
    line-height: 42px;
    margin-bottom: 40px;
  }
  .login_panel_input{
    font-size: 16px;
    font-weight: 400;
    color: #999999;
    line-height: 19px;
    margin-bottom: 24px;
    .input_login_custom{
      height: 62px;
      border-radius: 10px 10px 10px 10px;
      padding-left: 50px !important;
      .ant-input{
        height: 62px;
        font-size: 16px;
        font-weight: 400;
        color: #999999;
        line-height: 19px;
      }
    }
  }
  .login_panel_tips{
    font-size: 12px;
    font-weight: 400;
    color: #333333;
    line-height: 18px;
    letter-spacing: 1px;
    text-align: left;
    margin-bottom: 32px;
  }
  .btn_now{
    width: 166px !important;
    height: 54px !important;
    background: #28E04A !important;
    border-radius: 8px 8px 8px 8px;
    border-color: #28E04A !important;
    opacity: 1;
    font-size: 18px !important;
    font-weight: 600 !important;
    color: #000c17 !important;
  }
  .btn_now:hover{
    background: rgb(60, 244, 94) !important;
    color: #000c17 !important;
  }
}
</style>
<style lang="less">
.serviceGuideModal{
  .ant-modal-body{
    padding-bottom: 0 !important;
  }
}
.login_panel{
  .ant-tabs-content{
    min-height: 376px !important;
  }
  .ant-tabs-nav .ant-tabs-tab-active {
    color: black !important;
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 24px;
    line-height: 28px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    padding: 0 !important;
    margin: 0 59px 0 0 !important;
  }
  .ant-tabs-tab {
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 24px;
    color: #b2b2b2;
    line-height: 28px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    padding: 0 !important;
    margin: 0 59px 0 0 !important;
  }
  .ant-tabs-left-content {
    border: 0 !important;
  }
  .hide-divider .ant-tabs-tab {
    border: none !important;
  }
  .ant-tabs-bar{
    border-bottom: 0 !important;
  }
  .ant-tabs-bar .ant-tabs-left-bar{
    border-right: 0 !important;
    border-bottom: 0 !important;
  }
  .ant-tabs-content{
    min-height: 0;
  }
  /*tab标签页的title div*/
  .ant-tabs-tab{
    padding: 0;
    margin: 12px 48px 12px 16px;
  }
  .ant-tabs-ink-bar {
    background-color: green !important; /* 设置tabs下划线颜色为绿色 */
    height: 0 !important;
  }
  //悬浮其他tab标签页的颜色
  .ant-tabs-nav .ant-tabs-tab:hover {
    color: inherit !important;
  }
}
.custom-input {
  position: relative;
}

.custom-icon-lock {
  position: absolute;
  z-index: 666;
  top: 50%;
  left: 10px; /* 调整图片距离输入框的左侧距离 */
  transform: translateY(-50%);
  width: 36px; /* 调整图片宽度 */
  height: 36px; /* 保持高度自适应 */
}
.rotate {
  animation: rotate 1s linear infinite;
  transform-origin: 50% 50%; /* 设置旋转中心点为图片中心 */
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue